module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagMappingActionLeftInput.AddNewTagAction.left":"Key","tagMappingActionLeftInput.CopyValue.left":"Source Key","tagMappingActionLeftInput.RemoveTag.left":"Key","tagMappingActionLeftInput.Markup.left":"Markup %"}}')
  delete Component.options._Ctor
}
